import * as React from 'react';

import {Body} from 'shells/typography/body';

import './field-mapping.module.css';

type Props = {
    fieldLabel: string;
};

export function Description(props: Props) {
    return (
        <Body size='small'>
            This field maps to the <strong>{props.fieldLabel}</strong> field in Nutshell. Select
            where you’d like it to appear:
        </Body>
    );
}
